import styled from 'styled-components';
import { BORDER_RADIUS, COLORS, SIZE } from 'constants/variables';

export const SearchCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${COLORS.AbsoluteWhite};
  border-radius: ${BORDER_RADIUS.radius24};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s ease-in-out;
  height: auto;
  width:100%;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const CardContent = styled.div`
  padding: ${SIZE.max32};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${COLORS.RaisinBlack};
  margin: 0 0 8px 0;
`;

export const CardExcerpt = styled.p`
  font-size: 14px;
  color: ${COLORS.Gunmetal};
  margin: 0 0 16px 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardLink = styled.a`
  color: ${COLORS.Crimson};
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  margin-top: auto;
  align-self: flex-start;
  
  &:hover {
    text-decoration: underline;
  }
`;
